module.exports = __webpack_public_path__ + "static/media/membership.bdff3158.svg";